import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config } from './config';

let client: SupabaseClient | null = null;

/** Tạo khi cần dùng lần đầu, để màn hình báo thiếu cấu hình vẫn hiển thị được khi chưa có khóa. */
export function supabase(): SupabaseClient {
  if (!client) {
    client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false },
      realtime: { params: { eventsPerSecond: 10 } },
    });
  }
  return client;
}

/** Thay client (dùng trong test). */
export function setSupabaseForTest(c: SupabaseClient | null): void { client = c; }
